import React, { useState } from 'react'
import { getSizedImageUrl } from '@shopify/theme-images'
import { formatMoney } from '@shopify/theme-currency'
import { useSelector } from 'react-redux';
import { RootState } from '../store/reducers';

interface ProductRecomendationsProps {
  product: {
    title: string,
    description: string,
    url: string,
    // eslint-disable-next-line camelcase
    featured_image: string,
    images: string[],
    // eslint-disable-next-line camelcase
    price_varies: boolean,
    price: string | number,
    variants: any[]
  },
  withDescription?: boolean,
  canAddToCart?: boolean,
  desktopImageSize?: string,
  desktop2xImageSize?: string,
  mobileImageSize?: string,
}

const ProductCard = (props: ProductRecomendationsProps): JSX.Element => {
  const { product, withDescription, canAddToCart, desktopImageSize, mobileImageSize, desktop2xImageSize } = props;
  const [variant, setVariant] = useState(product.variants[0]);
  const [hideForm, setHideForm] = useState(true);
  const [disableAtc, setDisableAtc] = useState(true);
  const [image, setImage] = useState(product.featured_image);
  const selectLang = useSelector((state: RootState) => state.config.appLayerConfigSelectLang);
  const addLang = useSelector((state: RootState) => state.config.appLayerConfigSelectLang);
  const chooseLang = useSelector((state: RootState) => state.config.appLayerConfigSelectLang);

  const assemblePrice = (product) => {
    if (hideForm) {
      const {
        price_varies: priceVaries,
        price: prodPrice,
        compare_at_price: compareAtPrice,
      } = product;

      const pricePrependiture = (priceVaries ? 'From ' : '');
      const priceFormatted = formatMoney(prodPrice, window['theme'].moneyFormat);

      if (compareAtPrice > 0 && compareAtPrice !== prodPrice) {
        const compareAtPriceFormatted = formatMoney(compareAtPrice, window['theme'].moneyFormat);

        return (
          <p>
            {pricePrependiture} <s>({compareAtPriceFormatted})</s> {priceFormatted}
          </p>
        );
      }
      return <p>{pricePrependiture} {priceFormatted}</p>
    } else {
      const {
        price: prodPrice,
        compare_at_price: compareAtPrice,
      } = variant;
      const priceFormatted = formatMoney(prodPrice, window['theme'].moneyFormat);

      if (compareAtPrice > 0 && compareAtPrice !== prodPrice) {
        const compareAtPriceFormatted = formatMoney(compareAtPrice, window['theme'].moneyFormat);

        return (
          <p>
            <s>({compareAtPriceFormatted})</s> {priceFormatted}
          </p>
        );
      }

      return <p>{priceFormatted}</p>
    }
  }


  const dtImg = getSizedImageUrl(image, desktopImageSize ? desktopImageSize : '180x180');
  const dtImgSrcSet = `${dtImg} 1x, ${getSizedImageUrl(image, desktop2xImageSize ? desktop2xImageSize : '360x360')} 2x`;

  const mobImg = getSizedImageUrl(image, mobileImageSize ? mobileImageSize : '90x90');
  const srcset = `${mobImg} 1x, ${dtImg} 2x`;

  const onVariantSelected = (e) => {
    if (e.target.value === '') {
      setDisableAtc(true);
      return false
    }

    const variant = product.variants.find(variant => variant.id + '' === e.target.value);
    setVariant(variant);
    if (variant.featured_image) {
      setImage(variant.featured_image.src);
    }

    if (variant.available) {
      setDisableAtc(false);
    } else {
      setDisableAtc(true);
    }
    return true;
  }

  return (
    <>
      <div className={canAddToCart ? 'flex' : 'card-wrap'}>
        {/* Image */}
        <div className="cl-product-card-image">
          <picture>
            <source
              media="(max-width: 767px)"
              srcSet={srcset} />

            <img src={dtImg}
              srcSet={dtImgSrcSet}
              alt={product.title} />
          </picture>
        </div>

        {/* Description */}
        <div className="cl-product-card-info">
          <h2 className="cl-product-card-name bold">{product.title}</h2>
          {
            withDescription
              ? <p className="cl-product-card-description">
                {product.description.replace(/<\/?[^>]+(>|$)/g, '').substr(0, 50)}
              </p>
              : ''
          }
          <div className="cl-product-card-price">
            <div className="product-price-snippet">
              {assemblePrice(product)}
            </div>
          </div>

          {
            canAddToCart ?
              (
                product.variants.length > 1 ?
                  (
                    <div className="product-upsells__item__btn-container">
                      <button type="button" className={hideForm ? 'btn' : 'hide'} onClick={() => setHideForm(!hideForm)}>
                        {chooseLang}
                      </button>
                    </div>
                  )
                  : (<form action="/cart/add">
                    <input type="hidden" name="id" value={variant.id} />
                    <input type="hidden" name="quantity" value="1" />
                    <button type="submit" className="btn">{addLang}</button>
                  </form>)
              )
              : ''
          }
        </div>
      </div>

      <form method="post"
        action="/cart/add"
        id="product_form_5546607313054"
        acceptCharset="UTF-8"
        className={hideForm ? 'hide' : 'product-upsells__item-selection'}
        encType="multipart/form-data">
        <input type="hidden" name="form_type" value="product" />
        <input type="hidden" name="utf8" value="✓" />
        <input type="hidden" value="1" id="upsell-quantity-" name="quantity" />
        <div className="select-wrapper">
          <select name="id" className="select" onChange={onVariantSelected}>
            <option value="">{selectLang}</option>
            {
              product.variants.map((variant) => <option key={'upsell' + variant.id} value={variant.id}>{variant.title}</option>)
            }
          </select>
        </div>

        <button disabled={disableAtc} className="btn" type="submit">
          {addLang}
        </button>
      </form>
    </>
  )
};

export default ProductCard